import React, { createContext, useContext, useState, useCallback, useMemo, useEffect } from 'react';
import { useLocation } from 'react-router-dom'

const ThemeContext = createContext();

export const useThemeContext = () => useContext(ThemeContext);
const COLOR = "#54DE7E"
export const MOMO_COLOR = "#C0167C"
export const TIKI_COLOR = "#1A94FF"
export const EMED_COLOR = '#EC221F';
export default (props) => {
  const location = useLocation()
  const [theme, setTheme] = useState('light');

  const isLight = useMemo(() => theme === 'light', [theme]);
  const [mainColor, setMainColor] = useState(COLOR);
  const [textColor, setTextColor] = useState("#fff");

  useEffect(()=>{
    return () => {
      setDefaultColor()
    }
  },[location])
  const toggleTheme = useCallback(() => {
    setTheme(prev => (prev === 'light' ? 'dark' : 'light'));
  }, []);
  const setDefaultColor = () => {
    changeMainColor(COLOR, "#9498ac")
  }
  const setBlankColor = () => {
    changeMainColor("#fff", "#000")
  }
  const changeMainColor = (backgroundColor, textColor = null) => {
    if (!backgroundColor) backgroundColor = COLOR;
    setMainColor(backgroundColor);
    document.documentElement.style.setProperty('--color-primary', backgroundColor);
    if (textColor) {
      setTextColor(textColor)
      document.documentElement.style.setProperty('--color-text', textColor);
    }
  }

  return (
    <ThemeContext.Provider value={{
      theme, isLight, toggleTheme, changeMainColor,
      setDefaultColor,
      mainColor,
      defaultColor: COLOR,
      textColor,
      setBlankColor,
      TIKI_COLOR,
      MOMO_COLOR,
    }}>
      {props.children}
    </ThemeContext.Provider>
  );
};
